import {createSvgIcon} from '../create-svg-icon';

export const ArrowBackIosNewIcon = createSvgIcon(
  <path d="M17.77 3.77 16 2 6 12l10 10 1.77-1.77L9.54 12z" />
, 'ArrowBackIosNewOutlined');
